/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CustomForm from 'cio/models/custom-form';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import { FormType } from 'cio/utils/forms';
import { inject as service } from '@ember/service';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CustomFormsService from 'cio/services/custom-forms';

interface DataSourceLabelFormArgs {
  form?: FacebookLeadAdsForm | CustomForm;
  formId?: string;
  formType?: FormType;
}

export default class DataSourceLabelForm extends Component<DataSourceLabelFormArgs> {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;

  readonly FormType = FormType;

  get form() {
    if (this.args.form != null) {
      return this.args.form;
    }

    if (this.args.formId == null) {
      return null;
    }

    let { formId, formType } = this.args;
    if (formType === FormType.FacebookLeadAds) {
      return this.facebookLeadAds.forms.findBy('formId', formId);
    }

    return this.customForms.forms.findBy('formIdLowercase', formId);
  }

  constructor(owner: unknown, args: DataSourceLabelFormArgs) {
    super(owner, args);

    this.facebookLeadAds.initialize();
    this.customForms.initialize();
  }
}
